import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/containers/specifics/vendors/deals/[id]/estimations/Page";

export const PATH = (id: number): string => `/vendors/deals/${id}/estimations`;

function Estimations() {
	return (
		<>
			<NskHead title="見積り確認" />
			<Component />
		</>
	);
}

export default Estimations;
